import React, { useState } from "react";
import { useDispatch } from "react-redux";
import DeleteTenantDialog from "./DeleteTenantDialog";
import DeleteButton from "./../DeleteButton";
import { tenantmgmtService } from "../../services";
import { appActions, userActions } from "../../redux/actions";
import { getApiErrorMessage } from "../../helpers";
import { systemRoleService } from "../../modules/role-management/services";
import useAuth from "../../hooks/useAuth";

const getTenantId = (tenant) => tenant?.id || tenant?._id || tenant?.originalId || "";

const DeleteTenant = ({ tenant, onDeleteSuccess }) => {
  const dispatch = useDispatch();
  const { activeTenantId } = useAuth();
  const [isDialogOpen, setDialogOpen] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleDeleteClick = () => {
    setDialogOpen(true);
  };

  const handleDialogClose = () => {
    if (!loading) setDialogOpen(false);
  };

  const handleDeleteConfirm = async () => {
    const tenantId = getTenantId(tenant);
    if (!tenantId) {
      dispatch(appActions.apiErrorMessage("Tenant ID is missing."));
      return;
    }

    setLoading(true);
    try {
      await tenantmgmtService.deleteTenant(tenantId);
      try {
        await systemRoleService.detachTenantFromSystemRoles(tenant);
      } catch {
        // Tenant is already deleted; role cleanup is best-effort.
      }
      const deletedKeys = [tenant?.name, tenant?.slug, tenantId]
        .map((value) => String(value || "").trim().toLowerCase())
        .filter(Boolean);
      if (
        activeTenantId &&
        deletedKeys.includes(String(activeTenantId).trim().toLowerCase())
      ) {
        dispatch(userActions.clearActiveTenant());
      }
      dispatch(appActions.apiSuccessMessage("Tenant deleted successfully."));
      setDialogOpen(false);
      onDeleteSuccess?.(tenantId);
    } catch (err) {
      dispatch(appActions.apiErrorMessage(getApiErrorMessage(err) || "Failed to delete tenant."));
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <DeleteButton onDelete={handleDeleteClick} />
      <DeleteTenantDialog
        open={isDialogOpen}
        onClose={handleDialogClose}
        onConfirm={handleDeleteConfirm}
        tenantName={tenant?.name || getTenantId(tenant) || "this tenant"}
        loading={loading}
      />
    </>
  );
};

export default DeleteTenant;
